

/**
 * Renders a heading element with dynamic level.
 * @param {React.ReactNode} children - Content to display
 * @param {string} level - Heading level ('level1' to 'level6')
 * @param {string} [customClass] - Optional CSS class
 * @returns {JSX.Element|null} Heading element or null if invalid
 * 
 */

const HeadingWithLevel = ({ children, level, customClass }) => {
    const headingLevel = level.split('level')[1] // Extract the number from 'level1', 'level2', etc.
    if (headingLevel < 1 || headingLevel > 6) {
        console.error(`Invalid heading level: ${level}. It should be between level1 and level6.`);
        return null;
    }
  const HeadingTag = `h${headingLevel}`
  return (
    <HeadingTag className={customClass}>{children}</HeadingTag>
  )
}

export default HeadingWithLevel